import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// ── Data ──────────────────────────────────────────────────────────────────────
const paripatrakeList = [
  {
    id: 1,
    label: 'मुख्यमंत्री समृद्ध पंचायतराज अभियान',
    englishLabel: 'Chief Minister Samruddha Panchayat Raj Abhiyan',
    lastUpdated: 'बुधवार, 15 एप्रिल 2026, 07:34:46 AM',
    englishLastUpdated: 'Wednesday, 15 April 2026, 07:34:46 AM',
    content: [
      {
        id: 1,
        text: 'मुख्यमंत्री समृद्ध पंचायत राज अभियानांतर्गत विविध स्तरावरील मुल्यमापन काळावधी वाढविण्याबाबत.....शासन परिपत्रक दि.14 एप्रिल 2026.',
        englishText: 'Regarding extension of evaluation period at various levels under Chief Minister Samruddha Panchayat Raj Abhiyan... Government Circular dated 14 April 2026.',
        link: '#',
        highlighted: true,
      },
      {
        id: 2,
        text: '"मुख्यमंत्री समृद्ध पंचायत राज अभियान" अंतर्गत ग्रामपंचायतींकडून निवासी मालमत्ता कर व अन्य कर थकबाकी वसुलीत सवलत देणेबाबत... शासन निर्णय दि. 13 नोव्हेंबर 2025.',
        englishText: 'Regarding giving concession in recovery of residential property tax and other tax arrears by Gram Panchayats under "Chief Minister Samruddha Panchayat Raj Abhiyan"... Government Decision dated 13 November 2025.',
        link: '#',
      },
      {
        id: 3,
        text: 'मुख्यमंत्री समृद्ध पंचायतराज अभियानाची प्रभावी अंमलबजावणी बाबत ग्रामविकास विभाग पत्र 16 ऑक्टोबर 2025',
        englishText: 'Rural Development Department letter regarding effective implementation of Chief Minister Samruddha Panchayat Raj Abhiyan 16 October 2025',
        link: '#',
        alternateLink: '#',
      },
      {
        id: 4,
        text: 'मुख्यमंत्री समृद्ध पंचायतराज अभियानाची प्रभावी अंमलबजावणी व प्रचार प्रसिद्धीबाबत.... ग्रामविकास विभाग पत्र 16 ऑक्टोबर 2025.',
        englishText: 'Regarding effective implementation and publicity of Chief Minister Samruddha Panchayat Raj Abhiyan.... Rural Development Department letter 16 October 2025.',
        link: '#',
        alternateLink: '#',
      },
      {
        id: 5,
        text: 'आर.आर. (आबा) पाटील सुंदर गाव पुरस्कार योजनेचे विलीनीकरण मुख्यमंत्री समृद्ध पंचायत राज अभियान या योजनेमध्ये करण्याबाबत.- शासन निर्णय दि. 29 सप्टेंबर 2025',
        englishText: 'Regarding merger of R.R. (Aba) Patil Sundar Gaon Award Scheme into Chief Minister Samruddha Panchayat Raj Abhiyan. - Government Decision dated 29 September 2025',
        link: '#',
      },
      {
        id: 6,
        text: 'राज्यात मुख्यमंत्री समृद्ध पंचायतराज अभियान राबविण्याबाबत- शासान निर्णय दि. 6 ऑगस्ट 2025',
        englishText: 'Regarding implementation of Chief Minister Samruddha Panchayat Raj Abhiyan in the state - Government Decision dated 6 August 2025',
        link: '#',
        prefix: '+',
      },
    ],
  },
  {
    id: 2,
    label: 'माझं गाव, आरोग्य संपन्न गाव',
    englishLabel: 'My Village, Healthy Village',
    lastUpdated: 'सोमवार, 10 मार्च 2025, 09:15:00 AM',
    englishLastUpdated: 'Monday, 10 March 2025, 09:15:00 AM',
    content: [
      { id: 1, text: 'माझं गाव, आरोग्य संपन्न गाव अभियान - शासन परिपत्रक दि.10 मार्च 2025.', englishText: 'My Village, Healthy Village Campaign - Government Circular dated 10 March 2025.', link: '#', highlighted: true },
      { id: 2, text: 'माझं गाव, आरोग्य संपन्न गाव - अंमलबजावणी मार्गदर्शक सूचना, दि. 5 जानेवारी 2025.', englishText: 'My Village, Healthy Village - Implementation Guidelines, dated 5 January 2025.', link: '#' },
      { id: 3, text: 'ग्रामपंचायत स्तरावर आरोग्य सुविधा बळकटीकरण - शासन निर्णय दि. 20 डिसेंबर 2024.', englishText: 'Strengthening health facilities at Gram Panchayat level - Government Decision dated 20 December 2024.', link: '#', alternateLink: '#' },
    ],
  },
  {
    id: 3,
    label: 'शासकीय जमिनीवरील अतिक्रमणे नियमित करणेबाबत.',
    englishLabel: 'Regarding regularization of encroachments on government land.',
    lastUpdated: 'शुक्रवार, 14 फेब्रुवारी 2025, 11:00:00 AM',
    englishLastUpdated: 'Friday, 14 February 2025, 11:00:00 AM',
    content: [
      { id: 1, text: 'शासकीय जमिनीवरील अतिक्रमणे नियमित करण्याबाबत शासन परिपत्रक दि.14 फेब्रुवारी 2025.', englishText: 'Government Circular regarding regularization of encroachments on government land dated 14 February 2025.', link: '#', highlighted: true },
      { id: 2, text: 'महसूल विभाग - जमीन अतिक्रमण निर्मूलन मोहीम - शासन निर्णय दि. 1 जानेवारी 2025.', englishText: 'Revenue Department - Land Encroachment Eradication Campaign - Government Decision dated 1 January 2025.', link: '#' },
    ],
  },
  {
    id: 4,
    label: 'ग्रामपंचायत प्रशासक बाबत (prashasak)',
    englishLabel: 'Regarding Gram Panchayat Administrator',
    lastUpdated: 'बुधवार, 5 मार्च 2025, 02:30:00 PM',
    englishLastUpdated: 'Wednesday, 5 March 2025, 02:30:00 PM',
    content: [
      { id: 1, text: 'ग्रामपंचायत प्रशासक नियुक्ती व कार्यकाळ - शासन निर्णय दि. 5 मार्च 2025.', englishText: 'Gram Panchayat Administrator Appointment and Tenure - Government Decision dated 5 March 2025.', link: '#', highlighted: true },
      { id: 2, text: 'ग्रामपंचायत प्रशासकाचे अधिकार व कर्तव्ये - शासन परिपत्रक दि. 20 फेब्रुवारी 2025.', englishText: 'Rights and duties of Gram Panchayat Administrator - Government Circular dated 20 February 2025.', link: '#' },
      { id: 3, text: 'प्रशासक नियुक्ती संदर्भातील स्पष्टीकरण - शासन पत्र दि. 10 जानेवारी 2025.', englishText: 'Clarification regarding appointment of Administrator - Government Letter dated 10 January 2025.', link: '#', alternateLink: '#' },
    ],
  },
  {
    id: 5,
    label: 'ग्रामपंचायत निवडणूक विषयक- grampanchayat election',
    englishLabel: 'Gram Panchayat Election matters',
    lastUpdated: 'सोमवार, 17 फेब्रुवारी 2025, 10:00:00 AM',
    englishLastUpdated: 'Monday, 17 February 2025, 10:00:00 AM',
    content: [
      { id: 1, text: 'ग्रामपंचायत सार्वत्रिक निवडणूक 2025 - कार्यक्रम जाहीर - शासन परिपत्रक दि. 17 फेब्रुवारी 2025.', englishText: 'Gram Panchayat General Election 2025 - Program Announced - Government Circular dated 17 February 2025.', link: '#', highlighted: true },
      { id: 2, text: 'ग्रामपंचायत निवडणूक आचारसंहिता - शासन निर्णय दि. 1 फेब्रुवारी 2025.', englishText: 'Gram Panchayat Election Code of Conduct - Government Decision dated 1 February 2025.', link: '#' },
      { id: 3, text: 'थेट सरपंच निवडणूक - मतदार यादी तयार करण्याबाबत - शासन पत्र दि. 20 जानेवारी 2025.', englishText: 'Direct Sarpanch Election - Regarding preparation of voter list - Government Letter dated 20 January 2025.', link: '#', alternateLink: '#' },
    ],
  },
  {
    id: 6,
    label: 'ग्रामसभा आयोजन व ठराव',
    englishLabel: 'Gram Sabha Organization and Resolutions',
    lastUpdated: 'मंगळवार, 25 नोव्हेंबर 2024, 03:00:00 PM',
    englishLastUpdated: 'Tuesday, 25 November 2024, 03:00:00 PM',
    content: [
      { id: 1, text: 'ग्रामसभा नियमित आयोजन करण्याबाबत - शासन परिपत्रक दि. 25 नोव्हेंबर 2024.', englishText: 'Regarding regular organization of Gram Sabha - Government Circular dated 25 November 2024.', link: '#', highlighted: true },
      { id: 2, text: 'ग्रामसभा ठरावाचे अभिलेख जतन करणेबाबत - शासन पत्र दि. 10 ऑक्टोबर 2024.', englishText: 'Regarding preservation of records of Gram Sabha resolutions - Government Letter dated 10 October 2024.', link: '#' },
    ],
  },
  {
    id: 7,
    label: 'पाणी पुरवठा व स्वच्छता',
    englishLabel: 'Water Supply and Sanitation',
    lastUpdated: 'गुरुवार, 5 डिसेंबर 2024, 01:00:00 PM',
    englishLastUpdated: 'Thursday, 5 December 2024, 01:00:00 PM',
    content: [
      { id: 1, text: 'जलजीवन मिशन - अंमलबजावणी प्रगती अहवाल सादर करणेबाबत - शासन परिपत्रक दि. 5 डिसेंबर 2024.', englishText: 'Jal Jeevan Mission - Regarding submission of implementation progress report - Government Circular dated 5 December 2024.', link: '#', highlighted: true },
      { id: 2, text: 'ग्रामीण स्वच्छता अभियान - ODF+ दर्जा राखण्याबाबत - शासन निर्णय दि. 15 नोव्हेंबर 2024.', englishText: 'Rural Sanitation Campaign - Regarding maintaining ODF+ status - Government Decision dated 15 November 2024.', link: '#', alternateLink: '#' },
    ],
  },
  {
    id: 8,
    label: 'रोजगार हमी योजना (MGNREGS)',
    englishLabel: 'Employment Guarantee Scheme (MGNREGS)',
    lastUpdated: 'शुक्रवार, 20 सप्टेंबर 2024, 09:30:00 AM',
    englishLastUpdated: 'Friday, 20 September 2024, 09:30:00 AM',
    content: [
      { id: 1, text: 'MGNREGS - कामाची मागणी नोंदणी प्रक्रिया - शासन परिपत्रक दि. 20 सप्टेंबर 2024.', englishText: 'MGNREGS - Work demand registration process - Government Circular dated 20 September 2024.', link: '#', highlighted: true },
      { id: 2, text: 'महात्मा गांधी NREGS - मजुरी दर सुधारणा - शासन निर्णय दि. 1 एप्रिल 2024.', englishText: 'Mahatma Gandhi NREGS - Wage rate revision - Government Decision dated 1 April 2024.', link: '#' },
    ],
  },
  {
    id: 9,
    label: 'घरपट्टी व मालमत्ता कर',
    englishLabel: 'House Tax and Property Tax',
    lastUpdated: 'सोमवार, 2 सप्टेंबर 2024, 11:00:00 AM',
    englishLastUpdated: 'Monday, 2 September 2024, 11:00:00 AM',
    content: [
      { id: 1, text: 'घरपट्टी व मालमत्ता कर आकारणी - शासन परिपत्रक दि. 2 सप्टेंबर 2024.', englishText: 'House tax and property tax assessment - Government Circular dated 2 September 2024.', link: '#', highlighted: true },
      { id: 2, text: 'ग्रामपंचायत कर थकबाकी वसुलीबाबत - शासन निर्णय दि. 15 ऑगस्ट 2024.', englishText: 'Regarding recovery of Gram Panchayat tax arrears - Government Decision dated 15 August 2024.', link: '#' },
    ],
  },
  {
    id: 10,
    label: 'ई-ग्रामस्वराज्य पोर्टल',
    englishLabel: 'e-GramSwaraj Portal',
    lastUpdated: 'बुधवार, 14 ऑगस्ट 2024, 10:00:00 AM',
    englishLastUpdated: 'Wednesday, 14 August 2024, 10:00:00 AM',
    content: [
      { id: 1, text: 'ई-ग्रामस्वराज्य पोर्टल वर डेटा अद्ययावत करण्याबाबत - शासन परिपत्रक दि. 14 ऑगस्ट 2024.', englishText: 'Regarding updating data on e-GramSwaraj Portal - Government Circular dated 14 August 2024.', link: '#', highlighted: true },
      { id: 2, text: 'PFMS - निधी वितरण ट्रॅकिंग - शासन निर्णय दि. 1 जुलै 2024.', englishText: 'PFMS - Fund Distribution Tracking - Government Decision dated 1 July 2024.', link: '#', alternateLink: '#' },
    ],
  },
  // Pages 3-29 items (simplified)
  ...Array.from({ length: 95 }, (_, i) => ({
    id: i + 11,
    label: `शासननिर्णय व परिपत्रके - विषय क्र. ${i + 11}`,
    englishLabel: `Government Decisions & Circulars - Topic No. ${i + 11}`,
    lastUpdated: 'सोमवार, 1 जानेवारी 2024, 09:00:00 AM',
    englishLastUpdated: 'Monday, 1 January 2024, 09:00:00 AM',
    content: [
      {
        id: 1,
        text: `शासननिर्णय / परिपत्रक विषय क्र. ${i + 11} - संपूर्ण माहितीसाठी लिंकवर क्लिक करा.`,
        englishText: `Government Decision / Circular Topic No. ${i + 11} - Click the link for full information.`,
        link: '#',
        highlighted: true,
      },
    ],
  })),
];

const ITEMS_PER_PAGE = 5;

// ── Component ─────────────────────────────────────────────────────────────────
const Paripatrake = () => {
  const { language } = useLanguage();
  const [selectedItem, setSelectedItem] = useState(paripatrakeList[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = paripatrakeList.filter((item) => {
    const labelToSearch = language === 'marathi' ? item.label : item.englishLabel;
    return labelToSearch.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Build page numbers to show (with ellipsis)
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1, 2, 3, 4, 5);
      if (currentPage > 5 && currentPage < totalPages - 1) {
        pages.push('...', currentPage);
      } else {
        pages.push('...');
      }
      pages.push(totalPages);
    }
    return pages;
  };

  // Translations
  const t = {
    title: language === 'marathi' ? 'शासननिर्णय व परिपत्रके' : 'Government Decisions & Circulars',
    search: language === 'marathi' ? 'Search:' : 'Search:',
    noItems: language === 'marathi' ? 'कोणतेही परिपत्रके सापडली नाही' : 'No circulars found',
    selectItem: language === 'marathi' ? 'डाव्या बाजूने विषय निवडा' : 'Select a topic from the left',
    lastUpdated: language === 'marathi' ? 'Last Updated: ' : 'Last Updated: ',
    prev: language === 'marathi' ? 'Previous' : 'Previous',
    next: language === 'marathi' ? 'Next' : 'Next',
    altLink: language === 'marathi' ? 'Alternate link' : 'Alternate link'
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-4 items-start">

          {/* ── Left Sidebar ── */}
          <div className="w-72 flex-shrink-0">

            {/* Sidebar Header */}
            <div
              className="flex items-center gap-2 px-3 py-2.5 rounded-t-md font-semibold text-sm text-gray-800"
              style={{ backgroundColor: '#e8e8e8', borderLeft: '4px solid #f26b6b' }}
            >
              <span>📢</span>
              <span>{t.title}</span>
            </div>

            {/* Search Box */}
            <div className="bg-white border border-gray-200 px-3 py-2">
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 whitespace-nowrap">{t.search}</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                  className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-400"
                />
              </div>
            </div>

            {/* List Items */}
            <div className="bg-white border border-gray-200 border-t-0 flex flex-col gap-1 p-2">
              {paginated.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-4">{t.noItems}</p>
              ) : (
                paginated.map((item) => {
                  const itemLabel = language === 'marathi' ? item.label : item.englishLabel;
                  return (
                    <button
                      key={item.id}
                      onClick={() => setSelectedItem(item)}
                      className="w-full text-left text-sm font-medium px-3 py-2.5 rounded transition-all duration-150 text-white hover:opacity-90"
                      style={{
                        backgroundColor:
                          selectedItem?.id === item.id ? '#0891b2' : '#06b6d4',
                      }}
                    >
                      {itemLabel}
                    </button>
                  );
                })
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="bg-white border border-gray-200 border-t-0 px-2 py-2 flex flex-wrap items-center gap-1">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.prev}
                </button>

                {getPageNumbers().map((page, idx) =>
                  page === '...' ? (
                    <span key={`ellipsis-${idx}`} className="px-1 text-xs text-gray-500">...</span>
                  ) : (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className="w-7 h-7 text-xs rounded border transition-colors"
                      style={
                        currentPage === page
                          ? { backgroundColor: '#f26b6b', borderColor: '#f26b6b', color: 'white' }
                          : { borderColor: '#d1d5db' }
                      }
                    >
                      {page}
                    </button>
                  )
                )}

                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.next}
                </button>
              </div>
            )}
          </div>

          {/* ── Right Content Panel ── */}
          <div className="flex-1 bg-white border border-gray-200 rounded-md shadow-sm min-h-96">
            {selectedItem ? (
              <div className="p-5">

                {/* Title */}
                <h2
                  className="text-xl font-bold text-gray-800 border-b-2 pb-2 mb-1"
                  style={{ borderColor: '#f26b6b' }}
                >
                  {language === 'marathi' ? selectedItem.label : selectedItem.englishLabel}
                </h2>

                {/* Last Updated */}
                <p className="text-xs text-gray-500 text-right mb-5 italic">
                  {t.lastUpdated}{language === 'marathi' ? selectedItem.lastUpdated : selectedItem.englishLastUpdated}
                </p>

                {/* Content Items */}
                <div className="flex flex-col gap-4">
                  {selectedItem.content.map((entry) => {
                    const entryText = language === 'marathi' ? entry.text : entry.englishText;
                    return (
                      <div
                        key={entry.id}
                        className={`text-sm leading-relaxed px-3 py-2 rounded ${
                          entry.highlighted ? 'border-l-4 border-cyan-400' : ''
                        }`}
                        style={
                          entry.highlighted
                            ? { backgroundColor: '#e0f7fa' }
                            : {}
                        }
                      >
                        <p>
                          <span className="text-gray-500 mr-1">
                            {entry.prefix || '-'}
                          </span>
                          <a
                            href={entry.link}
                            className="hover:underline transition-colors"
                            style={{ color: '#1a56db' }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {entryText}
                          </a>
                          {entry.alternateLink && (
                            <a
                              href={entry.alternateLink}
                              className="ml-2 text-xs font-semibold hover:underline"
                              style={{ color: '#e53e3e' }}
                              target="_blank"
                              rel="noreferrer"
                            >
                              - {t.altLink}
                            </a>
                          )}
                        </p>
                      </div>
                    );
                  })}
                </div>

              </div>
            ) : (
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>{t.selectItem}</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Paripatrake;
